import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Fundamentals from './pages/Fundamentals';
import Printables from './pages/Printables';
import Stories from './pages/Stories';
import Story from './pages/Story';
import Printable from './pages/Printable';
import PageNotFound from './pages/PageNotFound';
import Connect from './pages/Connect';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <BrowserRouter>
       <Routes>
        <Route path="/" element={ <App/> } />
        <Route path="/fundamentals" element={ <Fundamentals/> } />
        <Route path="/stories" element={ <Stories/> } />
        <Route path="/connect" element={ <Connect/> } />
        <Route path="/printables" element={ <Printables/> } />
        <Route path="/story/:storyShortName" action={({ params }) => {}} element={ <Story /> } />
        <Route path="/printable/:printableShortName" action={({ params }) => {}} element={ <Printable /> } />
        <Route path="/*" element={ <PageNotFound/> } />
      </Routes>
      </BrowserRouter>,
    );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();